export default __webpack_public_path__ + "static/media/include_3@2x.e6e59620.jpg";